export default "__VITE_ASSET__rMGSI_nX__"